var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.827,
    height: 16.051,
    viewBox: "0 0 22.827 16.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M23.4,7.011A2.868,2.868,0,0,0,21.382,4.98c-1.78-.48-8.919-.48-8.919-.48s-7.138,0-8.919.48A2.868,2.868,0,0,0,1.527,7.011a30.089,30.089,0,0,0-.477,5.53,30.089,30.089,0,0,0,.477,5.53,2.826,2.826,0,0,0,2.018,2c1.78.48,8.919.48,8.919.48s7.138,0,8.919-.48a2.826,2.826,0,0,0,2.018-2,30.089,30.089,0,0,0,.477-5.53A30.089,30.089,0,0,0,23.4,7.011ZM10.129,15.936V9.147L16.1,12.542l-5.966,3.394Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGrey);
export default __webpack_public_path__ + "static/media/youtube_grey.c45fa6c062e7afd94ca541b8bf0d336a.svg";
export { ForwardRef as ReactComponent };